// extracted by mini-css-extract-plugin
export var legendIndicator = "_cp-1";
export var legendRight = "_cp-0";